// client
export const GET_ACCESS_TOKEN_COMPLETED = 'GET_ACCESS_TOKEN_COMPLETED'
export const GET_CLIENT_COMPLETED = 'GET_CLIENT_COMPLETED'
export const SET_AUTHENTICATED_STATE = 'SET_AUTHENTICATED_STATE'

// management
export const SET_READY_STATE = 'SET_READY_STATE'

// management/users_list
export const LIST_USERS_STARTED = 'LIST_USERS_STARTED'
export const LIST_USERS_COMPLETED = 'LIST_USERS_COMPLETED'
export const LIST_USERS_FAILED = 'LIST_USERS_FAILED'

// management/users_list/create_user_form
export const CREATE_USER_STARTED = 'CREATE_USER_STARTED'
export const CREATE_USER_COMPLETED = 'CREATE_USER_COMPLETED'
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED'

// management/user_details
export const GET_USER_STARTED = 'GET_USER_STARTED'
export const GET_USER_COMPLETED = 'GET_USER_COMPLETED'
export const GET_USER_FAILED = 'GET_USER_FAILED'

// management/user_details/lock_user_form
export const LOCK_USER_STARTED = 'LOCK_USER_STARTED'
export const LOCK_USER_COMPLETED = 'LOCK_USER_COMPLETED'
export const LOCK_USER_FAILED = 'LOCK_USER_FAILED'

// management/user_details/change_password_form
export const CHANGE_PASSWORD_STARTED = 'CHANGE_PASSWORD_STARTED'
export const CHANGE_PASSWORD_COMPLETED = 'CHANGE_PASSWORD_COMPLETED'
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'

// management/user_details/update_user_form
export const UPDATE_USER_STARTED = 'UPDATE_USER_STARTED'
export const UPDATE_USER_COMPLETED = 'UPDATE_USER_COMPLETED'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'

// management/user_details/assign_role_form
export const ASSIGN_ROLE_STARTED = 'ASSIGN_ROLE_STARTED'
export const ASSIGN_ROLE_COMPLETED = 'ASSIGN_ROLE_COMPLETED'
export const ASSIGN_ROLE_FAILED = 'ASSIGN_ROLE_FAILED'

// management/user_details/role_assignments_list
export const LIST_ROLE_ASSIGNMENTS_STARTED = 'LIST_ROLE_ASSIGNMENTS_STARTED'
export const LIST_ROLE_ASSIGNMENTS_COMPLETED = 'LIST_ROLE_ASSIGNMENTS_COMPLETED'
export const LIST_ROLE_ASSIGNMENTS_FAILED = 'LIST_ROLE_ASSIGNMENTS_FAILED'
export const UNASSIGN_ROLE_STARTED = 'UNASSIGN_ROLE_STARTED'
export const UNASSIGN_ROLE_COMPLETED = 'UNASSIGN_ROLE_COMPLETED'
export const UNASSIGN_ROLE_FAILED = 'UNASSIGN_ROLE_FAILED'

// management/user_details/logs_list
export const LIST_USER_LOGS_STARTED = 'LIST_USER_LOGS_STARTED'
export const LIST_USER_LOGS_COMPLETED = 'LIST_USER_LOGS_COMPLETED'
export const LIST_USER_LOGS_FAILED = 'LIST_USER_LOGS_FAILED'

// management/user_details/oauth_factors_list
export const LIST_OAUTH_FACTORS_STARTED = 'LIST_OAUTH_FACTORS_STARTED'
export const LIST_OAUTH_FACTORS_COMPLETED = 'LIST_OAUTH_FACTORS_COMPLETED'
export const LIST_OAUTH_FACTORS_FAILED = 'LIST_OAUTH_FACTORS_FAILED'

export const DELETE_OAUTH_FACTOR_STARTED = 'DELETE_OAUTH_FACTOR_STARTED'
export const DELETE_OAUTH_FACTOR_COMPLETED = 'DELETE_OAUTH_FACTOR_COMPLETED'
export const DELETE_OAUTH_FACTOR_FAILED = 'DELETE_OAUTH_FACTOR_FAILED'

// management/user_details/contacts_list
export const LIST_USER_CONTACTS_STARTED = 'LIST_USER_CONTACTS_STARTED'
export const LIST_USER_CONTACTS_COMPLETED = 'LIST_USER_CONTACTS_COMPLETED'
export const LIST_USER_CONTACTS_FAILED = 'LIST_USER_CONTACTS_FAILED'

export const ADD_USER_CONTACT_STARTED = 'ADD_USER_CONTACT_STARTED'
export const ADD_USER_CONTACT_COMPLETED = 'ADD_USER_CONTACT_COMPLETED'
export const ADD_USER_CONTACT_FAILED = 'ADD_USER_CONTACT_FAILED'

export const DELETE_USER_CONTACT_STARTED = 'DELETE_USER_CONTACT_STARTED'
export const DELETE_USER_CONTACT_COMPLETED = 'DELETE_USER_CONTACT_COMPLETED'
export const DELETE_USER_CONTACT_FAILED = 'DELETE_USER_CONTACT_FAILED'

export const RESEND_VERIFICATION_USER_CONTACT_STARTED = 'RESEND_VERIFICATION_USER_CONTACT_STARTED'
export const RESEND_VERIFICATION_USER_CONTACT_COMPLETED = 'RESEND_VERIFICATION_USER_CONTACT_COMPLETED'
export const RESEND_VERIFICATION_USER_CONTACT_FAILED = 'RESEND_VERIFICATION_USER_CONTACT_FAILED'

export const UPDATE_PRIMARY_CONTACT_STARTED = 'UPDATE_PRIMARY_CONTACT_STARTED'
export const UPDATE_PRIMARY_CONTACT_COMPLETED = 'UPDATE_PRIMARY_CONTACT_COMPLETED'
export const UPDATE_PRIMARY_CONTACT_FAILED = 'UPDATE_PRIMARY_CONTACT_FAILED'

// management/user_details/security
export const LIST_USER_SECOND_FACTORS_STARTED = 'LIST_USER_SECOND_FACTORS_STARTED'
export const LIST_USER_SECOND_FACTORS_COMPLETED = 'LIST_USER_SECOND_FACTORS_COMPLETED'
export const LIST_USER_SECOND_FACTORS_FAILED = 'LIST_USER_SECOND_FACTORS_FAILED'

// management/user_details/devices
export const LIST_USER_SESSIONS_STARTED = 'LIST_USER_SESSIONS_STARTED'
export const LIST_USER_SESSIONS_COMPLETED = 'LIST_USER_SESSIONS_COMPLETED'
export const LIST_USER_SESSIONS_FAILED = 'LIST_USER_SESSIONS_FAILED'

export const DELETE_USER_SESSION_STARTED = 'DELETE_USER_SESSION_STARTED'
export const DELETE_USER_SESSION_COMPLETED = 'DELETE_USER_SESSION_COMPLETED'
export const DELETE_USER_SESSION_FAILED = 'DELETE_USER_SESSION_FAILED'

// management/user_details/metadata
export const LIST_USER_METADATA_STARTED = 'LIST_USER_METADATA_STARTED'
export const LIST_USER_METADATA_COMPLETED = 'LIST_USER_METADATA_COMPLETED'
export const LIST_USER_METADATA_FAILED = 'LIST_USER_METADATA_FAILED'

export const UPDATE_USER_METADATA_STARTED = 'UPDATE_USER_METADATA_STARTED'
export const UPDATE_USER_METADATA_COMPLETED = 'UPDATE_USER_METADATA_COMPLETED'
export const UPDATE_USER_METADATA_FAILED = 'UPDATE_USER_METADATA_FAILED'

// management/logs_list
export const LIST_LOGS_STARTED = 'LIST_LOGS_STARTED'
export const LIST_LOGS_COMPLETED = 'LIST_LOGS_COMPLETED'
export const LIST_LOGS_FAILED = 'LIST_LOGS_FAILED'

// management/roles_list/create_role_form
export const CREATE_ROLE_STARTED = 'CREATE_ROLE_STARTED'
export const CREATE_ROLE_COMPLETED = 'CREATE_ROLE_COMPLETED'
export const CREATE_ROLE_FAILED = 'CREATE_ROLE_FAILED'

// management/roles_list
export const LIST_ROLES_STARTED = 'LIST_ROLES_STARTED'
export const LIST_ROLES_COMPLETED = 'LIST_ROLES_COMPLETED'
export const LIST_ROLES_FAILED = 'LIST_ROLES_FAILED'
export const DELETE_ROLE_STARTED = 'DELETE_ROLE_STARTED'
export const DELETE_ROLE_COMPLETED = 'DELETE_ROLE_COMPLETED'
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED'

// management/permission_assignments_list
export const LIST_PERMISSION_ASSIGNMENTS_STARTED = 'LIST_PERMISSION_ASSIGNMENTS_STARTED'
export const LIST_PERMISSION_ASSIGNMENTS_COMPLETED = 'LIST_PERMISSION_ASSIGNMENTS_COMPLETED'
export const LIST_PERMISSION_ASSIGNMENTS_FAILED = 'LIST_PERMISSION_ASSIGNMENTS_FAILED'

// management/template_list
export const LIST_EMAIL_TEMPLATES_STARTED = 'LIST_EMAIL_TEMPLATES_STARTED'
export const LIST_EMAIL_TEMPLATES_COMPLETED = 'LIST_EMAIL_TEMPLATES_COMPLETED'
export const LIST_EMAIL_TEMPLATES_FAILED = 'LIST_EMAIL_TEMPLATES_FAILED'
export const LIST_SMS_TEMPLATES_STARTED = 'LIST_SMS_TEMPLATES_STARTED'
export const LIST_SMS_TEMPLATES_COMPLETED = 'LIST_SMS_TEMPLATES_COMPLETED'
export const LIST_SMS_TEMPLATES_FAILED = 'LIST_SMS_TEMPLATES_FAILED'

export const GET_TEMPLATE_STARTED = 'GET_TEMPLATE_STARTED'
export const GET_TEMPLATE_COMPLETED = 'GET_TEMPLATE_COMPLETED'
export const GET_TEMPLATE_FAILED = 'GET_TEMPLATE_FAILED'

export const CREATE_TEMPLATE_STARTED = 'CREATE_TEMPLATE_STARTED'
export const CREATE_TEMPLATE_COMPLETED = 'CREATE_TEMPLATE_COMPLETED'
export const CREATE_TEMPLATE_FAILED = 'CREATE_TEMPLATE_FAILED'

export const RESTORE_TO_DEFAULT_TEMPLATE_STARTED = 'RESTORE_TO_DEFAULT_TEMPLATE_STARTED'
export const RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED = 'RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED'
export const RESTORE_TO_DEFAULT_TEMPLATE_FAILED = 'RESTORE_TO_DEFAULT_TEMPLATE_FAILED'

// currentuser
export const GET_CURRENT_USER_STARTED = 'GET_CURRENT_USER_STARTED'
export const GET_CURRENT_USER_COMPLETED = 'GET_CURRENT_USER_COMPLETED'
export const GET_CURRENT_USER_FAILED = 'GET_CURRENT_USER_FAILED'

// currentuser/permissions
export const LIST_PERMISSIONS_STARTED = 'LIST_PERMISSIONS_STARTED'
export const LIST_PERMISSIONS_COMPLETED = 'LIST_PERMISSIONS_COMPLETED'
export const LIST_PERMISSIONS_FAILED = 'LIST_PERMISSIONS_FAILED'

// currentuser/tokens
export const GENERATE_NEW_TOKEN_STARTED = 'GENERATE_NEW_TOKEN_STARTED'
export const GENERATE_NEW_TOKEN_COMPLETED = 'GENERATE_NEW_TOKEN_COMPLETED'
export const GENERATE_NEW_TOKEN_FAILED = 'GENERATE_NEW_TOKEN_FAILED'

export const CREATE_ACCESS_TOKEN_STARTED = 'CREATE_ACCESS_TOKEN_STARTED'
export const CREATE_ACCESS_TOKEN_COMPLETED = 'CREATE_ACCESS_TOKEN_COMPLETED'
export const CREATE_ACCESS_TOKEN_FAILED = 'CREATE_ACCESS_TOKEN_FAILED'

// everywhere
export const CLEAR_STATES = 'CLEAR_STATES'
export const CLEAR_ACTION_STATES = 'CLEAR_ACTION_STATES'
